import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=556fa79e&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=556fa79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556fa79e",
  null
  
)

export default component.exports